var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportContactsOutlookBlueSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5641",
    "data-name": "Group 5641",
    transform: "translate(-437 -421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1734",
    "data-name": "Group 1734",
    transform: "translate(437 421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#1450ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1385",
    "data-name": "Group 1385",
    transform: "translate(440 424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M12.7,6,6.72,10.965,4,8.708",
    transform: "translate(-1.352 -1.483)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_534",
    "data-name": "Rectangle 534",
    width: 14,
    height: 14,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportContactsOutlookBlueSuccessIcon);
export default __webpack_public_path__ + "static/media/import-contacts-outlook-blue-success-icon.f6c0729e467b1ebc0dd2584df271f11c.svg";
export { ForwardRef as ReactComponent };